import { ExpectedQueryParams } from '@shared/interfaces/expected-query-params.interface';
import { ExpectedQueryParamsConfig } from '@shared/utils/expected-query-params/expected-query-params.config';

export const parseQueryParams = (): ExpectedQueryParams => {
  const urlParams: URLSearchParams = new URLSearchParams(window.location.search);
  return {
    trazabilityCode: urlParams.get(ExpectedQueryParamsConfig.trazabilityCode) || undefined,
    ticketId: urlParams.get(ExpectedQueryParamsConfig.ticketId) || undefined,
    code: urlParams.get(ExpectedQueryParamsConfig.keycloakCode.code) || undefined,
    state: urlParams.get(ExpectedQueryParamsConfig.keycloakCode.state) || undefined,
  };
};
